import React, { useState } from 'react';
import { 
  PlusIcon, 
  PencilIcon, 
  TrashIcon, 
  EyeIcon,
  ChatBubbleLeftRightIcon,
  BriefcaseIcon,
  BuildingOfficeIcon,
  XMarkIcon,
  StarIcon,
  UserIcon
} from '@heroicons/react/24/outline';

const WorkspaceManager = () => {
  const [activeTab, setActiveTab] = useState('workspaces');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showWorkModal, setShowWorkModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showWorkViewModal, setShowWorkViewModal] = useState(false);
  const [showWorkEditModal, setShowWorkEditModal] = useState(false);
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);
  const [selectedWork, setSelectedWork] = useState(null);
  const [dateError, setDateError] = useState('');
  
  const [workspaces, setWorkspaces] = useState([
    {
      id: 1,
      name: 'Tech Hub Mumbai',
      department: 'IT & Development',
      issuedDate: '2024-01-15',
      status: 'Active',
      location: 'Mumbai, Maharashtra',
      capacity: 50,
      manager: 'Rajesh Kumar',
      contact: '9876543210'
    },
    {
      id: 2,
      name: 'Creative Studio Bangalore',
      department: 'Design & Creative',
      issuedDate: '2024-02-20',
      status: 'Active',
      location: 'Bangalore, Karnataka',
      capacity: 30,
      manager: 'Priya Sharma',
      contact: '9876543211'
    },
    {
      id: 3,
      name: 'Corporate Office Delhi',
      department: 'Administration',
      issuedDate: '2024-03-10',
      status: 'Inactive',
      location: 'Delhi, NCR',
      capacity: 100,
      manager: 'Amit Singh',
      contact: '9876543212'
    }
  ]);

  const [feedbacks, setFeedbacks] = useState([
    {
      id: 1,
      workspace: 'Tech Hub Mumbai',
      user: 'John Doe',
      rating: 5,
      comment: 'Excellent workspace with great amenities!',
      date: '2024-03-15',
      status: 'Approved'
    },
    {
      id: 2,
      workspace: 'Creative Studio Bangalore',
      user: 'Jane Smith',
      rating: 4,
      comment: 'Good environment, but parking could be better.',
      date: '2024-03-14',
      status: 'Pending'
    }
  ]);

  const [works, setWorks] = useState([
    {
      id: 1,
      workspace: 'Tech Hub Mumbai',
      taskName: 'Server Maintenance',
      assignedTo: 'Rajesh Kumar',
      startDate: '2025-03-15',
      endDate: '2025-04-15',
      status: 'In Progress',
      priority: 'High',
      description: 'Regular server maintenance and security updates',
      estimatedHours: 40
    },
    {
      id: 2,
      workspace: 'Creative Studio Bangalore',
      taskName: 'UI/UX Design Workshop',
      assignedTo: 'Priya Sharma',
      startDate: '2025-03-22',
      endDate: '2025-03-23',
      status: 'Completed',
      priority: 'Medium',
      description: 'Conducting design workshop for the team',
      estimatedHours: 16
    },
    {
      id: 3,
      workspace: 'Corporate Office Delhi',
      taskName: 'Annual Audit',
      assignedTo: 'Amit Singh',
      startDate: '2025-04-01',
      endDate: '2025-04-10',
      status: 'Pending',
      priority: 'High',
      description: 'Yearly financial and compliance audit',
      estimatedHours: 80
    }
  ]);

  const [newWorkspace, setNewWorkspace] = useState({
    name: '',
    department: '',
    location: '',
    capacity: '',
    manager: '',
    contact: ''
  });

  const [editWorkspaceData, setEditWorkspaceData] = useState({
    id: null,
    name: '',
    department: '',
    location: '',
    capacity: '',
    manager: '',
    contact: ''
  });

  const [newWork, setNewWork] = useState({
    workspace: '',
    taskName: '',
    assignedTo: '',
    startDate: '',
    endDate: '',
    priority: 'Medium',
    description: '',
    estimatedHours: ''
  });

  const [editWorkData, setEditWorkData] = useState({
    id: null,
    workspace: '',
    taskName: '',
    assignedTo: '',
    startDate: '',
    endDate: '',
    priority: 'Medium',
    description: '',
    estimatedHours: '',
    status: ''
  });

  const [newFeedback, setNewFeedback] = useState({
    workspace: '',
    rating: 5,
    comment: ''
  });

  const handleWorkStartDateChange = (e) => {
    const newStartDate = e.target.value;
    setNewWork({...newWork, startDate: newStartDate});
    if (newWork.endDate && newWork.endDate < newStartDate) {
      setDateError('End date cannot be earlier than start date');
    } else {
      setDateError('');
    }
  };

  const handleWorkEndDateChange = (e) => {
    const newEndDate = e.target.value;
    setNewWork({...newWork, endDate: newEndDate});
    if (newWork.startDate && newEndDate < newWork.startDate) {
      setDateError('End date cannot be earlier than start date');
    } else {
      setDateError('');
    }
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    if (value.length <= 500) {
      setNewWork({...newWork, description: value});
    }
  };

  const handleEstimatedHoursChange = (e) => {
    const value = e.target.value;
    if (value === '') {
      setNewWork({...newWork, estimatedHours: ''});
    } else {
      const numValue = parseFloat(value);
      if (!isNaN(numValue) && numValue >= 0 && numValue <= 100 && /^\d*\.?\d*$/.test(value)) {
        setNewWork({...newWork, estimatedHours: value});
      }
    }
  };

  const handleAddWorkspace = () => {
    if (!newWorkspace.name || !newWorkspace.department) {
      alert('Please fill in Workspace Name and Department');
      return;
    }
    
    const workspace = {
      id: workspaces.length + 1,
      ...newWorkspace,
      status: 'Active',
      issuedDate: new Date().toISOString().split('T')[0]
    };
    setWorkspaces([...workspaces, workspace]);
    setShowAddModal(false);
    setNewWorkspace({
      name: '',
      department: '',
      location: '',
      capacity: '',
      manager: '',
      contact: ''
    });
    alert('Workspace added successfully!');
  };

  const handleDeleteWorkspace = (id) => {
    if (window.confirm('Are you sure you want to delete this workspace?')) {
      setWorkspaces(workspaces.filter(w => w.id !== id));
      alert('Workspace deleted successfully!');
    }
  };

  const handleViewWorkspace = (workspace) => {
    setSelectedWorkspace(workspace);
    setShowViewModal(true);
  };

  const handleEditWorkspace = (workspace) => {
    setEditWorkspaceData({
      id: workspace.id,
      name: workspace.name,
      department: workspace.department,
      location: workspace.location,
      capacity: workspace.capacity,
      manager: workspace.manager,
      contact: workspace.contact
    });
    setShowEditModal(true);
  };

  const handleUpdateWorkspace = () => {
    if (!editWorkspaceData.name || !editWorkspaceData.department) {
      alert('Please fill in Workspace Name and Department');
      return;
    }
    
    const updatedWorkspaces = workspaces.map(workspace => 
      workspace.id === editWorkspaceData.id 
        ? { 
            ...workspace, 
            name: editWorkspaceData.name,
            department: editWorkspaceData.department,
            location: editWorkspaceData.location,
            capacity: editWorkspaceData.capacity,
            manager: editWorkspaceData.manager,
            contact: editWorkspaceData.contact
          }
        : workspace
    );
    setWorkspaces(updatedWorkspaces);
    setShowEditModal(false);
    alert('Workspace updated successfully!');
  };

  const handleAddWork = () => {
    if (!newWork.workspace || !newWork.taskName || !newWork.assignedTo) {
      alert('Please fill in all required fields');
      return;
    }
    
    if (newWork.taskName.length > 100) {
      alert('Task name cannot exceed 100 characters');
      return;
    }
    
    if (newWork.assignedTo.length > 100) {
      alert('Assigned To cannot exceed 100 characters');
      return;
    }
    
    if (newWork.description.length > 500) {
      alert('Description cannot exceed 500 characters');
      return;
    }
    
    if (!newWork.startDate || !newWork.endDate) {
      alert('Please select both start and end dates');
      return;
    }
    
    // Validate start date is from 2025 onwards
    const startDateObj = new Date(newWork.startDate);
    const minStartDate = new Date('2025-01-01');
    if (startDateObj < minStartDate) {
      alert('Start date must be from January 1, 2025 onwards');
      return;
    }
    
    // Validate end date is up to 2099
    const endDateObj = new Date(newWork.endDate);
    const maxEndDate = new Date('2099-12-31');
    if (endDateObj > maxEndDate) {
      alert('End date cannot be later than December 31, 2099');
      return;
    }
    
    if (newWork.endDate < newWork.startDate) {
      alert('End date cannot be earlier than start date');
      return;
    }
    
    if (newWork.estimatedHours !== '') {
      const hours = parseFloat(newWork.estimatedHours);
      if (hours < 0 || hours > 100) {
        alert('Estimated hours must be between 0 and 100');
        return;
      }
    }
    
    const work = {
      id: works.length + 1,
      ...newWork,
      status: 'Pending'
    };
    setWorks([...works, work]);
    setShowWorkModal(false);
    setNewWork({
      workspace: '',
      taskName: '',
      assignedTo: '',
      startDate: '',
      endDate: '',
      priority: 'Medium',
      description: '',
      estimatedHours: ''
    });
    setDateError('');
    alert('Work assignment added successfully!');
  };

  const handleViewWork = (work) => {
    setSelectedWork(work);
    setShowWorkViewModal(true);
  };

  const handleEditWork = (work) => {
    setEditWorkData({
      id: work.id,
      workspace: work.workspace,
      taskName: work.taskName,
      assignedTo: work.assignedTo,
      startDate: work.startDate,
      endDate: work.endDate,
      priority: work.priority,
      description: work.description || '',
      estimatedHours: work.estimatedHours || '',
      status: work.status
    });
    setShowWorkEditModal(true);
  };

  const handleUpdateWork = () => {
    if (!editWorkData.taskName || !editWorkData.assignedTo) {
      alert('Please fill in all required fields');
      return;
    }
    
    if (editWorkData.taskName.length > 100) {
      alert('Task name cannot exceed 100 characters');
      return;
    }
    
    if (editWorkData.assignedTo.length > 100) {
      alert('Assigned To cannot exceed 100 characters');
      return;
    }
    
    if (editWorkData.description.length > 500) {
      alert('Description cannot exceed 500 characters');
      return;
    }
    
    if (!editWorkData.startDate || !editWorkData.endDate) {
      alert('Please select both start and end dates');
      return;
    }
    
    const startDateObj = new Date(editWorkData.startDate);
    const minStartDate = new Date('2025-01-01');
    if (startDateObj < minStartDate) {
      alert('Start date must be from January 1, 2025 onwards');
      return;
    }
    
    const endDateObj = new Date(editWorkData.endDate);
    const maxEndDate = new Date('2099-12-31');
    if (endDateObj > maxEndDate) {
      alert('End date cannot be later than December 31, 2099');
      return;
    }
    
    if (editWorkData.endDate < editWorkData.startDate) {
      alert('End date cannot be earlier than start date');
      return;
    }
    
    if (editWorkData.estimatedHours !== '') {
      const hours = parseFloat(editWorkData.estimatedHours);
      if (hours < 0 || hours > 100) {
        alert('Estimated hours must be between 0 and 100');
        return;
      }
    }
    
    const updatedWorks = works.map(work => 
      work.id === editWorkData.id 
        ? { ...work, ...editWorkData }
        : work
    );
    setWorks(updatedWorks);
    setShowWorkEditModal(false);
    alert('Work assignment updated successfully!');
  };

  const handleDeleteWork = (id) => {
    if (window.confirm('Are you sure you want to delete this work assignment?')) {
      setWorks(works.filter(w => w.id !== id));
      alert('Work assignment deleted successfully!');
    }
  };

  const handleAddFeedback = () => {
    if (!newFeedback.workspace) {
      alert('Please select a workspace');
      return;
    }
    
    if (!newFeedback.comment || newFeedback.comment.trim() === '') {
      alert('Please enter your feedback comment');
      return;
    }
    
    if (newFeedback.comment.length > 500) {
      alert('Comment cannot exceed 500 characters');
      return;
    }
    
    const feedback = {
      id: feedbacks.length + 1,
      ...newFeedback,
      user: 'Current User',
      date: new Date().toISOString().split('T')[0],
      status: 'Pending'
    };
    setFeedbacks([...feedbacks, feedback]);
    setShowFeedbackModal(false);
    setNewFeedback({ workspace: '', rating: 5, comment: '' });
    alert('Feedback submitted successfully!');
  };

  const getStatusColor = (status) => {
    switch(status.toLowerCase()) {
      case 'active': return 'bg-green-100 text-green-700';
      case 'inactive': return 'bg-red-100 text-red-700';
      case 'completed': return 'bg-blue-100 text-blue-700';
      case 'in progress': return 'bg-yellow-100 text-yellow-700';
      case 'pending': return 'bg-orange-100 text-orange-700';
      case 'approved': return 'bg-green-100 text-green-700';
      default: return 'bg-gray-100 text-gray-700';
    }
  };

  const getPriorityColor = (priority) => {
    switch(priority.toLowerCase()) {
      case 'high': return 'bg-red-100 text-red-700';
      case 'medium': return 'bg-yellow-100 text-yellow-700';
      case 'low': return 'bg-green-100 text-green-700';
      default: return 'bg-gray-100 text-gray-700';
    }
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <StarIcon 
        key={index} 
        className={`w-4 h-4 inline-block ${index < rating ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} 
      />
    ));
  };

  const formatDateRange = (start, end) => {
    if (!start || !end) return 'Not specified';
    const startDate = new Date(start);
    const endDate = new Date(end);
    return `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Workspace Management</h1>
          <p className="text-gray-600 mt-2">Manage workspaces, feedback, and work assignments</p>
        </div>

        <div className="border-b border-gray-200 mb-6">
          <nav className="flex flex-wrap gap-2 sm:gap-4">
            <button
              onClick={() => setActiveTab('workspaces')}
              className={`px-4 py-2 text-md font-medium rounded-lg transition-all ${
                activeTab === 'workspaces'
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <BuildingOfficeIcon className="w-4 h-4 inline-block mr-2" />
              Workspaces
            </button>
            <button
              onClick={() => setActiveTab('feedback')}
              className={`px-4 py-2 text-md font-medium rounded-lg transition-all ${
                activeTab === 'feedback'
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <ChatBubbleLeftRightIcon className="w-4 h-4 inline-block mr-2" />
              Feedback
            </button>
            <button
              onClick={() => setActiveTab('workadd')}
              className={`px-4 py-2 text-md font-medium rounded-lg transition-all ${
                activeTab === 'workadd'
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <BriefcaseIcon className="w-4 h-4 inline-block mr-2" />
              Work Assignments
            </button>
          </nav>
        </div>

        {activeTab === 'workspaces' && (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold text-gray-800">All Workspaces</h2>
              <button
                onClick={() => setShowAddModal(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
              >
                <PlusIcon className="w-5 h-5" />
                Add Workspace
              </button>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Workspace Name</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Department</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Issued Date</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Location</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {workspaces.map((workspace) => (
                      <tr key={workspace.id} className="hover:bg-gray-50 transition-colors">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm font-medium text-gray-900">{workspace.name}</div>
                          <div className="text-sm text-gray-500">Capacity: {workspace.capacity}</div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{workspace.department}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{workspace.issuedDate}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{workspace.location}</td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className={`px-2 py-1 text-xs rounded-full ${getStatusColor(workspace.status)}`}>
                            {workspace.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                          <div className="flex gap-2">
                            <button 
                              onClick={() => handleViewWorkspace(workspace)}
                              className="text-blue-600 hover:text-blue-800"
                              title="View"
                            >
                              <EyeIcon className="w-5 h-5" />
                            </button>
                            <button 
                              onClick={() => handleEditWorkspace(workspace)}
                              className="text-green-600 hover:text-green-800"
                              title="Edit"
                            >
                              <PencilIcon className="w-5 h-5" />
                            </button>
                            <button 
                              onClick={() => handleDeleteWorkspace(workspace.id)}
                              className="text-red-600 hover:text-red-800"
                              title="Delete"
                            >
                              <TrashIcon className="w-5 h-5" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'feedback' && (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold text-gray-800">User Feedback</h2>
              <button
                onClick={() => setShowFeedbackModal(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
              >
                <PlusIcon className="w-5 h-5" />
                Add Feedback
              </button>
            </div>

            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
              {feedbacks.map((feedback) => (
                <div key={feedback.id} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
                  <div className="flex justify-between items-start mb-3">
                    <div className="flex items-center gap-2">
                      <UserIcon className="w-5 h-5 text-gray-400" />
                      <span className="font-medium text-gray-900">{feedback.user}</span>
                    </div>
                    <span className={`px-2 py-1 text-xs rounded-full ${getStatusColor(feedback.status)}`}>
                      {feedback.status}
                    </span>
                  </div>
                  <div className="mb-3">
                    <div className="text-sm text-gray-600 mb-1">Workspace: {feedback.workspace}</div>
                    <div className="flex items-center gap-1 mb-2">{renderStars(feedback.rating)}</div>
                    <p className="text-gray-700 text-sm">{feedback.comment}</p>
                  </div>
                  <div className="text-xs text-gray-400 mt-3">{feedback.date}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'workadd' && (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold text-gray-800">Work Assignments</h2>
              <button
                onClick={() => setShowWorkModal(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
              >
                <PlusIcon className="w-5 h-5" />
                Add Work
              </button>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Task Name</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Workspace</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Assigned To</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Duration</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Priority</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {works.map((work) => (
                      <tr key={work.id} className="hover:bg-gray-50 transition-colors">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm font-medium text-gray-900">{work.taskName}</div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{work.workspace}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{work.assignedTo}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                          {formatDateRange(work.startDate, work.endDate)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className={`px-2 py-1 text-xs rounded-full ${getPriorityColor(work.priority)}`}>
                            {work.priority}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className={`px-2 py-1 text-xs rounded-full ${getStatusColor(work.status)}`}>
                            {work.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                          <div className="flex gap-2">
                            <button 
                              onClick={() => handleViewWork(work)}
                              className="text-blue-600 hover:text-blue-800"
                              title="View"
                            >
                              <EyeIcon className="w-5 h-5" />
                            </button>
                            <button 
                              onClick={() => handleEditWork(work)}
                              className="text-green-600 hover:text-green-800"
                              title="Edit"
                            >
                              <PencilIcon className="w-5 h-5" />
                            </button>
                            <button 
                              onClick={() => handleDeleteWork(work.id)}
                              className="text-red-600 hover:text-red-800"
                              title="Delete"
                            >
                              <TrashIcon className="w-5 h-5" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* View Workspace Modal */}
        {showViewModal && selectedWorkspace && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl max-w-md w-full">
              <div className="flex justify-between items-center p-6 border-b">
                <h3 className="text-xl font-semibold">Workspace Details</h3>
                <button onClick={() => setShowViewModal(false)} className="text-gray-400 hover:text-gray-600">
                  <XMarkIcon className="w-6 h-6" />
                </button>
              </div>
              <div className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Workspace Name</label>
                  <p className="mt-1 text-gray-900">{selectedWorkspace.name}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Department</label>
                  <p className="mt-1 text-gray-900">{selectedWorkspace.department}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Location</label>
                  <p className="mt-1 text-gray-900">{selectedWorkspace.location || 'Not specified'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Capacity</label>
                  <p className="mt-1 text-gray-900">{selectedWorkspace.capacity || 'Not specified'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Manager</label>
                  <p className="mt-1 text-gray-900">{selectedWorkspace.manager || 'Not specified'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Contact Number</label>
                  <p className="mt-1 text-gray-900">{selectedWorkspace.contact || 'Not specified'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Issued Date</label>
                  <p className="mt-1 text-gray-900">{selectedWorkspace.issuedDate}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Status</label>
                  <span className={`mt-1 inline-block px-2 py-1 text-xs rounded-full ${getStatusColor(selectedWorkspace.status)}`}>
                    {selectedWorkspace.status}
                  </span>
                </div>
              </div>
              <div className="p-6 border-t flex justify-end">
                <button onClick={() => setShowViewModal(false)} className="px-4 py-2 bg-blue-600 text-white rounded-lg">
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Edit Workspace Modal */}
        {showEditModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
              <div className="flex justify-between items-center p-6 border-b">
                <h3 className="text-xl font-semibold">Edit Workspace</h3>
                <button onClick={() => setShowEditModal(false)} className="text-gray-400 hover:text-gray-600">
                  <XMarkIcon className="w-6 h-6" />
                </button>
              </div>
              <div className="p-6 space-y-4">
                <input 
                  type="text" 
                  placeholder="Workspace Name *" 
                  className="w-full px-3 py-2 border rounded-lg" 
                  value={editWorkspaceData.name} 
                  onChange={(e) => setEditWorkspaceData({...editWorkspaceData, name: e.target.value.slice(0, 100)})}
                  maxLength={100}
                />
                <input 
                  type="text" 
                  placeholder="Department *" 
                  className="w-full px-3 py-2 border rounded-lg" 
                  value={editWorkspaceData.department} 
                  onChange={(e) => setEditWorkspaceData({...editWorkspaceData, department: e.target.value.slice(0, 100)})}
                  maxLength={100}
                />
                <input 
                  type="text" 
                  placeholder="Capacity" 
                  className="w-full px-3 py-2 border rounded-lg" 
                  value={editWorkspaceData.capacity} 
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === '' || (/^\d+$/.test(value) && parseInt(value) <= 1000)) {
                      setEditWorkspaceData({...editWorkspaceData, capacity: value});
                    }
                  }}
                />
                <input 
                  type="text" 
                  placeholder="Manager Name" 
                  className="w-full px-3 py-2 border rounded-lg" 
                  value={editWorkspaceData.manager} 
                  onChange={(e) => setEditWorkspaceData({...editWorkspaceData, manager: e.target.value.slice(0, 100)})}
                  maxLength={100}
                />
                <input 
                  type="text" 
                  placeholder="Location" 
                  className="w-full px-3 py-2 border rounded-lg" 
                  value={editWorkspaceData.location} 
                  onChange={(e) => setEditWorkspaceData({...editWorkspaceData, location: e.target.value.slice(0, 100)})}
                  maxLength={100}
                />
                <input 
                  type="text" 
                  placeholder="Contact Number (10 digits)" 
                  className="w-full px-3 py-2 border rounded-lg" 
                  value={editWorkspaceData.contact} 
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value) && value.length <= 10) {
                      setEditWorkspaceData({...editWorkspaceData, contact: value});
                    }
                  }}
                  maxLength={10}
                />
              </div>
              <div className="p-6 border-t flex justify-end gap-3">
                <button onClick={() => setShowEditModal(false)} className="px-4 py-2 border rounded-lg">Cancel</button>
                <button onClick={handleUpdateWorkspace} className="px-4 py-2 bg-blue-600 text-white rounded-lg">Update Workspace</button>
              </div>
            </div>
          </div>
        )}

        {/* View Work Modal */}
        {showWorkViewModal && selectedWork && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl max-w-md w-full">
              <div className="flex justify-between items-center p-6 border-b">
                <h3 className="text-xl font-semibold">Work Assignment Details</h3>
                <button onClick={() => setShowWorkViewModal(false)} className="text-gray-400 hover:text-gray-600">
                  <XMarkIcon className="w-6 h-6" />
                </button>
              </div>
              <div className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Task Name</label>
                  <p className="mt-1 text-gray-900">{selectedWork.taskName}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Workspace</label>
                  <p className="mt-1 text-gray-900">{selectedWork.workspace}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Assigned To</label>
                  <p className="mt-1 text-gray-900">{selectedWork.assignedTo}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Duration</label>
                  <p className="mt-1 text-gray-900">{formatDateRange(selectedWork.startDate, selectedWork.endDate)}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Priority</label>
                  <span className={`mt-1 inline-block px-2 py-1 text-xs rounded-full ${getPriorityColor(selectedWork.priority)}`}>
                    {selectedWork.priority}
                  </span>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Status</label>
                  <span className={`mt-1 inline-block px-2 py-1 text-xs rounded-full ${getStatusColor(selectedWork.status)}`}>
                    {selectedWork.status}
                  </span>
                </div>
                {selectedWork.description && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Description</label>
                    <p className="mt-1 text-gray-900">{selectedWork.description}</p>
                  </div>
                )}
                {selectedWork.estimatedHours && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Estimated Hours</label>
                    <p className="mt-1 text-gray-900">{selectedWork.estimatedHours} hours</p>
                  </div>
                )}
              </div>
              <div className="p-6 border-t flex justify-end">
                <button onClick={() => setShowWorkViewModal(false)} className="px-4 py-2 bg-blue-600 text-white rounded-lg">
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Edit Work Modal */}
        {showWorkEditModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
              <div className="flex justify-between items-center p-6 border-b">
                <h3 className="text-xl font-semibold">Edit Work Assignment</h3>
                <button onClick={() => setShowWorkEditModal(false)} className="text-gray-400 hover:text-gray-600">
                  <XMarkIcon className="w-6 h-6" />
                </button>
              </div>
              <div className="p-6 space-y-4">
                <select 
                  className="w-full px-3 py-2 border rounded-lg"
                  value={editWorkData.workspace}
                  onChange={(e) => setEditWorkData({...editWorkData, workspace: e.target.value})}
                >
                  <option value="">Select Workspace</option>
                  {workspaces.map(w => <option key={w.id} value={w.name}>{w.name}</option>)}
                </select>
                
                <div>
                  <input 
                    type="text" 
                    placeholder="Task Name * (Max 100 characters)" 
                    className="w-full px-3 py-2 border rounded-lg" 
                    value={editWorkData.taskName} 
                    onChange={(e) => setEditWorkData({...editWorkData, taskName: e.target.value.slice(0, 100)})}
                    maxLength={100}
                  />
                  <div className="text-right text-xs text-gray-400 mt-1">{editWorkData.taskName.length}/100</div>
                </div>
                
                <div>
                  <input 
                    type="text" 
                    placeholder="Assigned To * (Max 100 characters)" 
                    className="w-full px-3 py-2 border rounded-lg" 
                    value={editWorkData.assignedTo} 
                    onChange={(e) => setEditWorkData({...editWorkData, assignedTo: e.target.value.slice(0, 100)})}
                    maxLength={100}
                  />
                  <div className="text-right text-xs text-gray-400 mt-1">{editWorkData.assignedTo.length}/100</div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Start Date (From 01-01-2025)</label>
                  <input 
                    type="date" 
                    className="w-full px-3 py-2 border rounded-lg" 
                    value={editWorkData.startDate} 
                    min="2025-01-01"
                    max="2099-12-31"
                    onChange={(e) => setEditWorkData({...editWorkData, startDate: e.target.value})}
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">End Date (Up to 31-12-2099)</label>
                  <input 
                    type="date" 
                    className="w-full px-3 py-2 border rounded-lg" 
                    value={editWorkData.endDate} 
                    min={editWorkData.startDate || "2025-01-01"}
                    max="2099-12-31"
                    onChange={(e) => setEditWorkData({...editWorkData, endDate: e.target.value})}
                  />
                  {editWorkData.startDate && editWorkData.endDate && editWorkData.endDate < editWorkData.startDate && (
                    <p className="text-red-500 text-xs mt-1">End date cannot be earlier than start date</p>
                  )}
                </div>
                
                <div>
                  <textarea 
                    placeholder="Description (Max 500 characters)" 
                    className="w-full px-3 py-2 border rounded-lg" 
                    rows="3"
                    value={editWorkData.description} 
                    onChange={(e) => {
                      if (e.target.value.length <= 500) {
                        setEditWorkData({...editWorkData, description: e.target.value});
                      }
                    }}
                    maxLength={500}
                  />
                  <div className="text-right text-xs text-gray-400 mt-1">{editWorkData.description.length}/500 characters</div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Estimated Hours (0-100 hours)</label>
                  <input 
                    type="number" 
                    placeholder="Estimated Hours" 
                    className="w-full px-3 py-2 border rounded-lg" 
                    value={editWorkData.estimatedHours} 
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '') {
                        setEditWorkData({...editWorkData, estimatedHours: ''});
                      } else {
                        const numValue = parseFloat(value);
                        if (!isNaN(numValue) && numValue >= 0 && numValue <= 100) {
                          setEditWorkData({...editWorkData, estimatedHours: value});
                        }
                      }
                    }}
                    min="0"
                    max="100"
                    step="0.5"
                  />
                  <p className="text-xs text-gray-400 mt-1">Enter positive numbers only, up to 100 hours</p>
                </div>
                
                <select 
                  className="w-full px-3 py-2 border rounded-lg"
                  value={editWorkData.priority}
                  onChange={(e) => setEditWorkData({...editWorkData, priority: e.target.value})}
                >
                  <option value="Low">Low Priority</option>
                  <option value="Medium">Medium Priority</option>
                  <option value="High">High Priority</option>
                </select>
                
                <select 
                  className="w-full px-3 py-2 border rounded-lg"
                  value={editWorkData.status}
                  onChange={(e) => setEditWorkData({...editWorkData, status: e.target.value})}
                >
                  <option value="Pending">Pending</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Completed">Completed</option>
                </select>
              </div>
              <div className="p-6 border-t flex justify-end gap-3">
                <button onClick={() => setShowWorkEditModal(false)} className="px-4 py-2 border rounded-lg">Cancel</button>
                <button onClick={handleUpdateWork} className="px-4 py-2 bg-blue-600 text-white rounded-lg">Update Work</button>
              </div>
            </div>
          </div>
        )}

        {/* Add Workspace Modal */}
        {showAddModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
              <div className="flex justify-between items-center p-6 border-b">
                <h3 className="text-xl font-semibold">Add New Workspace</h3>
                <button onClick={() => setShowAddModal(false)} className="text-gray-400 hover:text-gray-600">
                  <XMarkIcon className="w-6 h-6" />
                </button>
              </div>
              <div className="p-6 space-y-4">
                <input 
                  type="text" 
                  placeholder="Workspace Name *" 
                  className="w-full px-3 py-2 border rounded-lg" 
                  value={newWorkspace.name} 
                  onChange={(e) => setNewWorkspace({...newWorkspace, name: e.target.value.slice(0, 100)})}
                  maxLength={100}
                />
                <input 
                  type="text" 
                  placeholder="Department *" 
                  className="w-full px-3 py-2 border rounded-lg" 
                  value={newWorkspace.department} 
                  onChange={(e) => setNewWorkspace({...newWorkspace, department: e.target.value.slice(0, 100)})}
                  maxLength={100}
                />
                <input 
                  type="text" 
                  placeholder="Capacity" 
                  className="w-full px-3 py-2 border rounded-lg" 
                  value={newWorkspace.capacity} 
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === '' || (/^\d+$/.test(value) && parseInt(value) <= 1000)) {
                      setNewWorkspace({...newWorkspace, capacity: value});
                    }
                  }}
                />
                <input 
                  type="text" 
                  placeholder="Manager Name" 
                  className="w-full px-3 py-2 border rounded-lg" 
                  value={newWorkspace.manager} 
                  onChange={(e) => setNewWorkspace({...newWorkspace, manager: e.target.value.slice(0, 100)})}
                  maxLength={100}
                />
                <input 
                  type="text" 
                  placeholder="Location" 
                  className="w-full px-3 py-2 border rounded-lg" 
                  value={newWorkspace.location} 
                  onChange={(e) => setNewWorkspace({...newWorkspace, location: e.target.value.slice(0, 100)})}
                  maxLength={100}
                />
                <input 
                  type="text" 
                  placeholder="Contact Number (10 digits)" 
                  className="w-full px-3 py-2 border rounded-lg" 
                  value={newWorkspace.contact} 
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value) && value.length <= 10) {
                      setNewWorkspace({...newWorkspace, contact: value});
                    }
                  }}
                  maxLength={10}
                />
              </div>
              <div className="p-6 border-t flex justify-end gap-3">
                <button onClick={() => setShowAddModal(false)} className="px-4 py-2 border rounded-lg">Cancel</button>
                <button onClick={handleAddWorkspace} className="px-4 py-2 bg-blue-600 text-white rounded-lg">Add Workspace</button>
              </div>
            </div>
          </div>
        )}

        {/* Add Work Modal */}
        {showWorkModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
              <div className="flex justify-between items-center p-6 border-b">
                <h3 className="text-xl font-semibold">Add Work Assignment</h3>
                <button onClick={() => setShowWorkModal(false)} className="text-gray-400 hover:text-gray-600">
                  <XMarkIcon className="w-6 h-6" />
                </button>
              </div>
              <div className="p-6 space-y-4">
                <select 
                  className="w-full px-3 py-2 border rounded-lg" 
                  value={newWork.workspace} 
                  onChange={(e) => setNewWork({...newWork, workspace: e.target.value})}
                >
                  <option value="">Please Select Workspace </option>
                  {workspaces.map(w => <option key={w.id} value={w.name}>{w.name}</option>)}
                </select>
                
                <div>
                  <input 
                    type="text" 
                    placeholder="Task Name * (Max 100 characters)" 
                    className="w-full px-3 py-2 border rounded-lg" 
                    value={newWork.taskName} 
                    onChange={(e) => setNewWork({...newWork, taskName: e.target.value.slice(0, 100)})}
                    maxLength={100}
                  />
                  <div className="text-right text-xs text-gray-400 mt-1">{newWork.taskName.length}/100 characters</div>
                </div>
                
                <div>
                  <input 
                    type="text" 
                    placeholder="Assigned To * (Max 100 characters)" 
                    className="w-full px-3 py-2 border rounded-lg" 
                    value={newWork.assignedTo} 
                    onChange={(e) => setNewWork({...newWork, assignedTo: e.target.value.slice(0, 100)})}
                    maxLength={100}
                  />
                  <div className="text-right text-xs text-gray-400 mt-1">{newWork.assignedTo.length}/100 characters</div>
                </div>
                
                <div>
                  <input 
                    type="date" 
                    className="w-full px-3 py-2 border rounded-lg" 
                    value={newWork.startDate} 
                    min="2025-01-01"
                    max="2099-12-31"
                    onChange={handleWorkStartDateChange}
                  />
                  <p className="text-xs text-gray-400 mt-1">Select starting date from January 1, 2025</p>
                </div>
                
                <div>
                  
                  <input 
                    type="date" 
                    className="w-full px-3 py-2 border rounded-lg" 
                    value={newWork.endDate} 
                    min={newWork.startDate || "2025-01-01"}
                    max="2099-12-31"
                    onChange={handleWorkEndDateChange}
                  />
                  {dateError && (
                    <p className="text-red-500 text-xs mt-1">{dateError}</p>
                  )}
                  <p className="text-xs text-gray-400 mt-1">End date cannot be earlier than start date</p>
                </div>
                
                <div>
                  <textarea 
                    placeholder="Description (Max 500 characters)" 
                    className="w-full px-3 py-2 border rounded-lg" 
                    rows="3"
                    value={newWork.description} 
                    onChange={handleDescriptionChange}
                    maxLength={500}
                  />
                </div>
                
                <div>
                  <input 
                    type="number" 
                    placeholder="Estimated Hours" 
                    className="w-full px-3 py-2 border rounded-lg" 
                    value={newWork.estimatedHours} 
                    onChange={handleEstimatedHoursChange}
                    min="0"
                    max="100"
                    step="0.5"
                  />
                  <p className="text-xs text-gray-400 mt-1">Enter positive numbers only, up to 100 hours</p>
                </div>
                
                <select 
                  className="w-full px-3 py-2 border rounded-lg" 
                  value={newWork.priority} 
                  onChange={(e) => setNewWork({...newWork, priority: e.target.value})}
                >
                  <option value="Low">Low Priority</option>
                  <option value="Medium">Medium Priority</option>
                  <option value="High">High Priority</option>
                </select>
              </div>
              <div className="p-6 border-t flex justify-end gap-3">
                <button onClick={() => setShowWorkModal(false)} className="px-4 py-2 border rounded-lg">Cancel</button>
                <button onClick={handleAddWork} className="px-4 py-2 bg-blue-600 text-white rounded-lg">Add Work</button>
              </div>
            </div>
          </div>
        )}

        {/* Add Feedback Modal */}
        {showFeedbackModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl max-w-md w-full">
              <div className="flex justify-between items-center p-6 border-b">
                <h3 className="text-xl font-semibold">Add Feedback</h3>
                <button onClick={() => setShowFeedbackModal(false)} className="text-gray-400 hover:text-gray-600">
                  <XMarkIcon className="w-6 h-6" />
                </button>
              </div>
              <div className="p-6 space-y-4">
                <select 
                  className="w-full px-3 py-2 border rounded-lg" 
                  value={newFeedback.workspace} 
                  onChange={(e) => setNewFeedback({...newFeedback, workspace: e.target.value})}
                >
                  <option value="">Select Workspace *</option>
                  {workspaces.map(w => <option key={w.id} value={w.name}>{w.name}</option>)}
                </select>
                
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium">Rating:</span>
                  {[1,2,3,4,5].map(r => (
                    <button key={r} onClick={() => setNewFeedback({...newFeedback, rating: r})} className="focus:outline-none">
                      <StarIcon className={`w-6 h-6 ${r <= newFeedback.rating ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} />
                    </button>
                  ))}
                </div>
                
                <div>
                  <textarea 
                    placeholder="Your feedback * (Max 500 characters)" 
                    className="w-full px-3 py-2 border rounded-lg" 
                    rows="4" 
                    value={newFeedback.comment} 
                    onChange={(e) => {
                      if (e.target.value.length <= 500) {
                        setNewFeedback({...newFeedback, comment: e.target.value});
                      }
                    }}
                    maxLength={500}
                  />
                  <div className="text-right text-xs text-gray-400 mt-1">{newFeedback.comment.length}/500 characters</div>
                </div>
              </div>
              <div className="p-6 border-t flex justify-end gap-3">
                <button onClick={() => setShowFeedbackModal(false)} className="px-4 py-2 border rounded-lg">Cancel</button>
                <button onClick={handleAddFeedback} className="px-4 py-2 bg-blue-600 text-white rounded-lg">Submit Feedback</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkspaceManager;